import { useTranslation } from 'react-i18next'


import useModalStore from '@features/modal/model'
import ErrorInfoModal from '@features/modal/ui/error'
import styles from '@features/modal/ui/styles.module.scss'


interface OpenErrorInfoModalProps {
  title?: string;
  description?: string;
  extendedErrorMessage?: string;
}

export default function useErrorInfoModal () {
  const { t: tc } = useTranslation('common')
  const { openModal, closeModal } = useModalStore()

  const openErrorInfoModal = ({
    title,
    description,
    extendedErrorMessage,
  }: OpenErrorInfoModalProps = {}) => {
    openModal('info', <ErrorInfoModal extendedErrorMessage={extendedErrorMessage} />, {
      title: title ?? tc('modal.error.title'),
      description: description ?? tc('modal.error.description'),
      classes: {
        content: styles['error-info-modal-content'],
      },
    })
  }

  const closeErrorInfoModal = () => {
    closeModal('info')
  }

  return {
    openErrorInfoModal,
    closeErrorInfoModal,
  }
}
